import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useHierarquia = () => {
  const [hierarquia, setHierarquia] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchHierarquia = async () => {
      try {
        const response = await httpClient.get(`/api/fornecedor/hierarquia`);

        const options = response.data.map(
          (hierarquia: { value: number; label: string }) => ({
            value: hierarquia.value.toString(),
            label: hierarquia.label,
          }),
        );
        setHierarquia(options);
      } catch (error) {
        console.error('Erro ao buscar Hierarquia', error);
      }
    };

    fetchHierarquia();
  }, []);

  return hierarquia;
};
